import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 1400,
    margin: '0 auto',
  },
  backButton: {
    textTransform: 'none',
    color: theme.palette.text.primary,
    fontWeight: 600,
    marginBottom: theme.spacing(3),
    paddingLeft: 0,
  },
  certificatesHeader: {
    marginBottom: theme.spacing(2),
  },
  certificatesTitle: {
    fontSize: 22,
    fontWeight: 700,
    color: theme.palette.text.primary,
  },
  filterRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  sortRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexShrink: 0,
  },
  sortLabel: {
    fontSize: 13,
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
  },
  sortSelect: {
    fontSize: 13,
    height: 36,
    '& .MuiOutlinedInput-input': {
      paddingTop: theme.spacing(0.75),
      paddingBottom: theme.spacing(0.75),
    },
  },
  emptyState: {
    padding: theme.spacing(6),
    display: 'flex',
    justifyContent: 'center',
  },
  emptyText: {
    fontSize: 14,
    color: theme.palette.text.secondary,
  },
}))

export default useStyles
